import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

const createDownloadExtensionTrackingService = (track: TrackFn) => {
    return {
        trackDownloadExtensionAction: (category: string = "download extension page", subName?: string) => {
            track(category, "click", `download extension button${subName ? `/${subName}` : ""}`);
        },
    };
};

export default createDownloadExtensionTrackingService;
